import React, { useState } from 'react';
import { Button, Typography, Box, Grid, TextField } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
interface QuoteFormProps {
  /** Called after a successful submission (e.g. to auto-close a dialog). */
  onSuccess?: () => void;
  /** Hide the small heading/intro above the fields (used when a dialog title already exists). */
  hideHeading?: boolean;
}
export function QuoteForm({
  onSuccess,
  hideHeading = false
}: QuoteFormProps) {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setTimeout(() => {
      setStatus('success');
      onSuccess?.();
    }, 1500);
  };
  if (status === 'success') {
    return <Box sx={{
      textAlign: 'center',
      py: 4
    }} data-id="element-113">
        <CheckCircleOutlineIcon color="success" sx={{
        fontSize: 64,
        mb: 2
      }} data-id="element-114" />
        <Typography variant="h4" color="primary.main" gutterBottom fontWeight="bold" data-id="element-115">
          Request Received!
        </Typography>
        <Typography variant="body1" color="text.secondary" data-id="element-116">
          Thank you for reaching out. A member of our team will contact you
          shortly to schedule your free consultation.
        </Typography>
        <Button variant="outlined" sx={{
        mt: 4
      }} onClick={() => setStatus('idle')} data-id="element-117">
          Send Another Request
        </Button>
      </Box>;
  }
  return <form onSubmit={handleSubmit} data-id="element-118">
      {!hideHeading && <>
          <Typography variant="h5" color="primary.main" fontWeight="bold" gutterBottom data-id="element-119">
            Tell Us About Your Project
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{
        mb: 4
      }} data-id="element-120">
            No commitment required. We respect your privacy.
          </Typography>
        </>}

      <Grid container spacing={3} data-id="element-121">
        <Grid item xs={12} sm={6} data-id="element-122">
          <TextField fullWidth label="First Name" required variant="outlined" data-id="element-123" />
        </Grid>
        <Grid item xs={12} sm={6} data-id="element-124">
          <TextField fullWidth label="Last Name" required variant="outlined" data-id="element-125" />
        </Grid>
        <Grid item xs={12} sm={6} data-id="element-126">
          <TextField fullWidth label="Phone Number" required variant="outlined" type="tel" data-id="element-127" />
        </Grid>
        <Grid item xs={12} sm={6} data-id="element-128">
          <TextField fullWidth label="Email Address" required variant="outlined" type="email" data-id="element-129" />
        </Grid>
        <Grid item xs={12} data-id="element-130">
          <TextField fullWidth label="Project Details (Optional)" multiline rows={4} variant="outlined" placeholder="Tell us what kind of patio cover you're looking for..." data-id="element-131" />
        </Grid>
        <Grid item xs={12} data-id="element-132">
          <Button type="submit" variant="contained" color="secondary" size="large" fullWidth disabled={status === 'submitting'} sx={{
          py: 2,
          fontSize: '1.1rem'
        }} data-id="element-133">
            {status === 'submitting' ? 'Sending...' : 'Get My Free Quote'}
          </Button>
        </Grid>
      </Grid>
    </form>;
}